<template>
  <FormLabel :ok="ok" :increased="increased" :text="text" :error="error" :class="{'disabled':disabled, 'filled' : value}">
    <input class="formfield" :placeholder="placeholder" ref="input" :required="required"
           type="text" 
           :name="name"
           @blur="filledCheck"
           :disabled="disabled"
            v-maska="mask"
            @keydown.down="()=>options?($refs.droplist.optionFocus(0)):false"
           v-model="val">
    <DropList v-if="options"
      :options="options"
      :search="val"
      v-model="val"
      ref="droplist"
      @toInput="$refs.input.focus()"
      @input="blur"
      />
  </FormLabel> 
</template>

<script>
import FormLabel from '@/components/FormLabel.vue'
import FormField from '@/mixins/FormField.vue'
import { maska } from 'maska'
import DropList from './DropList.vue'

export default {
  directives: { maska },
  components: { FormLabel, DropList },
  mixins: [FormField],
  props: {
    options: {type: Array},
    mask: {type: String},
    customError: {type: String},
    name: {type: String, required: true},
    value: {type: String, default: ''},
    text: {type: String, required: true},
    placeholder: {type: String},
    validation: {type: Function, default: ()=>''},
    filled: {type: Function, default: (v)=>v?true:false},
    disabled: { type: Boolean, default: false },
    increased: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    errorcont: { type: Object }
  },
  data: ()=>({
    err: ''
  }),
  computed:{
    error: {
      get(){
        return this.err || this.customError
      },
      set(v){
        this.err = v
      },
      cache: false
    },
    ok(){
      if (!this.value || !this.filled(this.value) || !!this.error) return false
      return true
    },
    val: {
      get () { return this.value },
      set (value) { this.$emit('input', value) },
    },
  },
  mounted(){
    if (this.value) {
      this.label.classList.add('filled')
      this.error = this.validation(this.value)
    }
    else
      this.label.classList.remove('filled')      
  },
  watch: {
    value(val, old){
      if (val != old)
        this.$emit('input', val)
      this.error = ''
      if (val)
        this.error = this.validation(val)
      if (!this.error && this.required) this.filledCheck()
    },
    error(val) {
      if (this.errorcont)
        this.$set(this.errorcont, this.name, val)
    },
    required() {
      this.filledCheck()
    }
  },
  methods:{
    test(){
      this.$refs.droplist.focus()
    },
    blur(){
      this.$refs.input.blur() 
      let unfocusable = ()=> this.$refs.input.blur() 
      this.$refs.input.addEventListener('focus', unfocusable, false);
      setTimeout(()=>this.$refs.input.removeEventListener('focus', unfocusable, false), 200)
    },
    filledCheck(){
      if (!this.filled(this.value)) {
        if (this.required)
          this.error = "Заполните поле"
        else if (this.error == "Заполните поле")
          this.error = ''
      }
    }
  }
}
</script>

<style lang="sass">

</style>